import { hasValue } from '../helpers';
export default [
    function () {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                message: '=eeeMessage',
            },
            link: function (scope, elem, attrs) {
                scope.$watch(() => scope.ctrl.message.id, (newId, oldId) => {
                    if (hasValue(newId) && newId !== oldId) {
                        scope.ctrl.update();
                    }
                });
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    const getIcon = (msgType) => {
                        switch (msgType) {
                            case 'image':
                                return 'ic_image_24px.svg';
                            case 'video':
                                return 'ic_movie_24px.svg';
                            case 'audio':
                                return 'ic_mic_24px.svg';
                            case 'location':
                                return 'ic_location_on_24px.svg';
                            case 'file':
                                if (this.message.file.type === 'image/gif') {
                                    return 'ic_image_24px.svg';
                                }
                                return 'ic_insert_drive_file_24px.svg';
                            case 'ballot':
                                return 'ic_poll_24px.svg';
                            default:
                                return null;
                        }
                    };
                    this.update = () => {
                        this.icon = getIcon(this.message.type);
                        this.altText = this.message.type + ' icon';
                    };
                    this.$onInit = function () {
                        this.update();
                    };
                }],
            template: `
                <img ng-if="ctrl.icon !== null" ng-src="img/{{ ctrl.icon }}" alt="{{ ctrl.altText }}">
            `,
        };
    },
];
